<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="margin-left: -93px;text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            >
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>
            <v-btn
              outline
              :color="theme.color"
              @click="goToShop()"
            >{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
      </div>-->
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </div>-->
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>
                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('idcard') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('หมายเลขบัตรประชาชน (ไทย)')"
                    :data-vv-as="$t('หมายเลขบัตรประชาชน')"
                    outline
                    name="idcard"
                    @keypress="isNumber"
                    placeholder="หมายเลขบัตร 13 หลัก"
                    v-validate="'required|max:13'"
                    v-model="inputRabbit.idcard"
                    light
                    :color="theme.color"
                    :error="errors.has('idcard') ? true : false"
                    :error-messages="
                      errors.has('idcard') ? errors.first('idcard') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('nation') }"
                  class="mb-1"
                >
                  <v-autocomplete
                    v-model="inputRabbit.country"
                    :items="country"
                    outline
                    item-text="name"
                    item-value="name"
                    light
                    name="nation"
                    :color="theme.color"
                    :label="$t('สัญชาติ')"
                    :data-vv-as="$t('สัญชาติ')"
                    persistent-hint
                    :error="errors.has('nation') ? true : false"
                    :error-messages="
                      errors.has('nation') ? errors.first('nation') : ''
                    "
                  />
                </div>

                <div>
                  <v-menu
                    ref="menu"
                    v-model="birthdatemenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <div :class="{ 'has-error': errors.has('birthdate') }">
                        <v-text-field
                          :label="$t('วัน/เดือน/ปีเกิด (ค.ศ.)')"
                          :data-vv-as="$t('วัน/เดือน/ปีเกิด')"
                          outline
                          name="birthdate"
                          v-validate="'required'"
                          :value="
                            moment(inputRabbit.birthdate).format('DD/MM/YYYY')
                          "
                          light
                          :color="theme.color"
                          :error="errors.has('birthdate') ? true : false"
                          :error-messages="
                            errors.has('birthdate')
                              ? errors.first('birthdate')
                              : ''
                          "
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      ref="picker"
                      :color="theme.color"
                      v-model="inputRabbit.birthdate"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                    ></v-date-picker>
                  </v-menu>
                </div>

                <div :class="{ 'has-error': errors.has('prefix') }">
                  <v-select
                    :label="$t('คำนำหน้าชื่อ')"
                    :data-vv-as="$t('คำนำหน้าชื่อ')"
                    outline
                    name="prefix"
                    :items="['นาย', 'นาง', 'นางสาว']"
                    v-validate="'required'"
                    v-model="inputRabbit.prefix"
                    light
                    :color="theme.color"
                    :error="errors.has('first_name') ? true : false"
                    :error-messages="
                      errors.has('prefix') ? errors.first('prefix') : ''
                    "
                  ></v-select>
                </div>

                <div
                  :class="{ 'has-error': errors.has('first_name') }"
                  class="ml-1"
                >
                  <v-text-field
                    :label="$t('ชื่อจริง')"
                    :data-vv-as="$t('ชื่อจริง')"
                    outline
                    name="first_name"
                    v-validate="'required'"
                    v-model="inputRabbit.first_name"
                    light
                    :color="theme.color"
                    :error="errors.has('first_name') ? true : false"
                    :error-messages="
                      errors.has('first_name') ? errors.first('first_name') : ''
                    "
                  ></v-text-field>
                </div>

                <div
                  :class="{ 'has-error': errors.has('last_name') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('นามสกุล')"
                    :data-vv-as="$t('นามสกุล')"
                    outline
                    name="last_name"
                    v-validate="'required'"
                    v-model="inputRabbit.last_name"
                    light
                    :color="theme.color"
                    :error="errors.has('last_name') ? true : false"
                    :error-messages="
                      errors.has('last_name') ? errors.first('last_name') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div :class="{ 'has-error': errors.has('email') }" class="mb-1">
                  <v-text-field
                    :label="$t('Email')"
                    :data-vv-as="$t('Email')"
                    outline
                    name="email"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      email: true
                    }"
                    v-model="inputRabbit.email"
                    :error="errors.has('email') ? true : false"
                    :error-messages="
                      errors.has('email') ? errors.first('email') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('รหัสไปรษณีย์') }"
                  class="mb-1"
                >
                  <thai-address-input
                    v-model="inputRabbit.zipcode"
                    type="zipcode"
                    @select="onSelectAddress"
                    :label="$t('รหัสไปรษณีย์')"
                    :data-vv-as="$t('รหัสไปรษณีย์')"
                    outline
                    name="รหัสไปรษณีย์"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('รหัสไปรษณีย์') ? true : false"
                    :error-messages="
                      errors.has('รหัสไปรษณีย์')
                        ? errors.first('รหัสไปรษณีย์')
                        : ''
                    "
                  ></thai-address-input>
                </div>
                <div
                  :class="{ 'has-error': errors.has('จังหวัด') }"
                  class="mb-1"
                >
                  <thai-address-input
                    v-model="inputRabbit.province"
                    type="province"
                    @select="onSelectAddress"
                    :label="$t('จังหวัด')"
                    :data-vv-as="$t('จังหวัด')"
                    outline
                    name="จังหวัด"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('จังหวัด') ? true : false"
                    :error-messages="
                      errors.has('จังหวัด') ? errors.first('จังหวัด') : ''
                    "
                  ></thai-address-input>
                </div>
                <div :class="{ 'has-error': errors.has('เขต') }" class="mb-1">
                  <thai-address-input
                    v-model="inputRabbit.district"
                    type="amphoe"
                    @select="onSelectAddress"
                    :label="$t('อำเภอ/เขต')"
                    :data-vv-as="$t('เขต')"
                    outline
                    name="เขต"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('เขต') ? true : false"
                    :error-messages="
                      errors.has('เขต') ? errors.first('เขต') : ''
                    "
                  ></thai-address-input>
                </div>
                <div :class="{ 'has-error': errors.has('แขวง') }" class="mb-1">
                  <thai-address-input
                    v-model="inputRabbit.sub_district"
                    type="district"
                    @select="onSelectAddress"
                    :label="$t('ตำบล/แขวง')"
                    :data-vv-as="$t('แขวง')"
                    outline
                    name="แขวง"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('แขวง') ? true : false"
                    :error-messages="
                      errors.has('แขวง') ? errors.first('แขวง') : ''
                    "
                  ></thai-address-input>
                </div>

                <div
                  :class="{ 'has-error': errors.has('shippingAddress') }"
                  class="mb-1"
                >
                  <v-textarea
                    outline
                    :label="$t('Shipping Address')"
                    :placeholder="
                      $t('Ex. Address No., Village, Alley, and Road')
                    "
                    name="shippingAddress"
                    rows="5"
                    :data-vv-as="$t('Shipping Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{
                      required: true,
                      isBearhousezipcode: [cart.length, isBearhouse]
                    }"
                    light
                    :color="theme.color"
                    :error="errors.has('shippingAddress') ? true : false"
                    :error-messages="
                      errors.has('shippingAddress')
                        ? errors.first('shippingAddress')
                        : ''
                    "
                  ></v-textarea>
                </div>
                <div
                  :class="{ 'has-error': errors.has('taxdeduction') }"
                  class="mb-1"
                >
                  <v-checkbox
                    v-model="inputRabbit.taxdeduction"
                    name="taxdeduction"
                    class="mx-2 mt-0"
                    :color="theme.color"
                    label="ต้องการเอกสารสำหรับนำไปลดหย่อนภาษี"
                    :error="errors.has('taxdeduction') ? true : false"
                    :error-messages="
                      errors.has('taxdeduction')
                        ? errors.first('taxdeduction')
                        : ''
                    "
                  ></v-checkbox>
                </div>

                <div
                  v-if="$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                >
                  <v-text-field
                    outline
                    :label="$t('The 1 Card Number') + ` (${$t('Optional')})`"
                    name="remark"
                    :data-vv-as="$t('The 1 Card Number')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-text-field>
                </div>

                <template
                  v-if="
                    pageProfile && pageProfile.pageid && shippinglist && !isOoca
                  "
                >
                  <shipping-type
                    :bearhouseshippingprice="bearhouseshippingprice"
                    :cdsshippingprice="cdsshippingprice"
                    v-model="shippingType"
                    :shippinglist="shippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3
                  class="headline mb-3 text-xs-center"
                  :style="{ color: theme.color }"
                >
                  {{ $t('Payment Detail') }}
                </h3>

                <cart-summary
                  :cdsshippingprice="cdsshippingprice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :total="total"
                  :totalincludediscount="totalincludediscount"
                  :discount="discount"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                ></cart-summary>

                <div
                  v-if="!$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('Remark')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div style="padding-bottom: 25px">
                    <v-card>
                      <v-card-text>
                        <!-- Cash on Delivery -->
                        <template
                          v-if="
                            shippingType && shippingType.type == 'cod_charge'
                          "
                        >
                          <h3 class="text-xs-center">{{ $t('cod_charge') }}</h3>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="loading || isCartOutOfStock"
                                @click="handleSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{ $t('Proceed Payment') }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="true">
                            <div>
                              <form
                                @submit="submit2c2p"
                                ref="form2c2p"
                                id="2c2p-payment-form"
                                method="POST"
                                :action="`https://2c2pgateway.zwiz.ai/demo.php?date=${new Date()}`"
                              >
                                <input
                                  type="hidden"
                                  v-model="orderid"
                                  name="orderid"
                                />
                                <input
                                  type="hidden"
                                  v-model="amount"
                                  name="amount"
                                />
                                <input type="hidden" value="bec" name="theme" />
                                <input
                                  type="hidden"
                                  v-model="pageid"
                                  name="pageid"
                                />
                                <input
                                  type="hidden"
                                  v-model="serverUrl"
                                  name="serverUrl"
                                />
                              </form>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <div class="text-xs-left">
                                <span>
                                  <span>
                                    <v-checkbox
                                      color="orange"
                                      input-value="true"
                                      value
                                      readonly
                                      style="display: inline-block"
                                      hide-details
                                    ></v-checkbox>
                                  </span>
                                  <span>
                                    คลิกดำเนินการต่อเพื่อยอมรับ
                                    <a style="color: orange"
                                      >นโยบายความเป็นส่วนตัว</a
                                    >
                                    และ
                                    <a style="color: orange"
                                      >เงื่อนไขการบริการ</a
                                    >
                                    ของเรา
                                    กรุณาทำความเข้าใจข้อมูลความคุ้มครองอย่างละเอียด
                                    ก่อนซื้อกรมธรรม์ประกันภัย
                                    <span style="color: red">*</span>
                                  </span>
                                </span>
                              </div>
                              <div class="text-xs-left mt-3">
                                <span>
                                  <span>
                                    <v-checkbox
                                      color="orange"
                                      input-value="true"
                                      value
                                      readonly
                                      style="display: inline-block"
                                      hide-details
                                    ></v-checkbox>
                                  </span>
                                  <span>
                                    ข้าพเข้ายืนยันว่า
                                    ไม่เคยรู้ว่ามีอาการที่รับรู้ได้ด้วยตัวเอง
                                    หรือเคยได้รับการวินิจฉัย หรือการตรวจรักษา
                                    หรือคำแนะนำจากแพทย์เกี่ยวกับโรคหัวใจ
                                    อาการเจ็บหน้าอก โรคความดันโลหิตสูง
                                    โรคทางสมอง โรคปอด
                                    โรคเนื้องอกหรือมะเร็งโรคเบาหวาน โรคไต โรคตับ
                                    ภูมิคุ้มกันบกพร่อง โรคลมชัก ไข้รูมาติค
                                    โรคเก๊าท์ โรคกระดูก ข้อต่อ/กล้ามเนื้อ
                                    โรคเกี่ยวกับระบบทางเดินปัสสาวะและระบบสืบพันธุ์
                                    โรคเลือด โรคที่เกี่ยวกับต่อมไทรอยด์ หรือ
                                    ต่อมไร้ท่ออื่นๆ โรคเกี่ยวกับระบบประสาท
                                    โรคพิษสุราเรื้อรัง
                                    โรคหรือความผิดปกติอื่นๆที่ร้ายแรง
                                    หรือมีส่วนใดส่วนหนึ่งพิการหรือทุพพลภาพ
                                    และในระยะเวลา 5 ปีที่ผ่านมา
                                    ไม่เคยเจ็บป่วยเพราะโรคร้ายแรงจนทำให้ต้องได้รับการผ่าตัด
                                    ไม่เคยใช้ยาเสพติดให้โทษ ดื่มสุรา สิ่งมึนเมา
                                    หรือ เครื่องดื่มที่มีแอลกอฮอล์เป็นประจำ
                                    และบิดามารดาไม่เคยเป็นหรือเสียชีวิตเกี่ยวกับมะเร็งลำใส้
                                    หรือมะเร็งระบบสืบพันธุ์มาก่อน
                                    <span style="color: red">*</span>
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div>
                              โปรดเลือกช่องทางในช่องที่คุณต้องการจะรับข่าวสารจากเรา
                              ดังนี้
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  v-if="isCDS && transferType == '2c2p'"
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                                <v-btn
                                  dark
                                  v-else
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>

                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="qrHandleSubmit"
                                  :loading="pageLoading || loadingQrcode"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
            <!-- <div class="text-xs-center">
              <div>
                กรุณาจ่ายเงินภายใน
                <span :style="{color: theme.color}">{{timer}}</span> วินาที
                <br />หากแสกนแล้วโปรดรอซักครู่
                <br />ติดปัญหากรุณาติดต่อแอดมิน
              </div>
            </div>-->
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainTransfer from './MainTransfer'
import ThaiAddressInput from '@/components/ThaiAddressInput'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import country from '@/assets/js/country.js'

export default {
  mixins: [MainTransfer],
  components: {
    ThaiAddressInput
  },
  data() {
    return {
      transferType: '2c2p',
      birthdatemenu: false,
      inputRabbit: {
        prefix: '',
        first_name: '',
        last_name: '',
        province: '',
        district: '',
        sub_district: '',
        zipcode: '',
        address: '',
        phoneno: '',
        email: '',
        idcard: '',
        taxdeduction: ''
      }
    }
  },
  computed: {
    serverUrl() {
      return config.getConfig('serverUrl')
    },
    country() {
      return country
    },
    moment() {
      return moment
    }
  },
  mounted() {},
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    onSelectAddress(address) {
      this.inputRabbit.sub_district = address.district
      this.inputRabbit.district = address.amphoe
      this.inputRabbit.province = address.province
      this.inputRabbit.zipcode = address.zipcode
    },
    handleSubmit: function () {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }
        vm.loading = true
        var total = vm.total
        if (vm.shippingType) {
          total += vm.shippingType.value
        }
        var payment
        if (vm.transferType) {
          payment = '2c2p'
        } else {
          payment = null
        }
        var note = this.paymentSlipImage

        let data = {
          amount: vm.totalPrice.toFixed(2).toString().replace('.', ''),
          pageid: vm.pageid,
          userid: vm.userid,
          app: vm.app,
          name: vm.inputRabbit.first_name + ' ' + vm.inputRabbit.last_nam,
          address: vm.shippingAddress,
          phone: vm.customerPhone,
          payment: '2c2p',
          nameaddress:
            vm.inputRabbit.first_name +
            ' ' +
            vm.inputRabbit.last_name +
            ' , ' +
            vm.shippingAddress +
            ' , ' +
            vm.customerPhone,
          shippingtype: vm.shippingType ? vm.shippingType.type : null,
          note: note,
          remark:
            this.pageProfile.type == 'monobo'
              ? this.remark + ';;' + this.bankname
              : this.remark,
          shippingcharge: (vm.shippingType ? vm.shippingType.value : 0)
            .toFixed(2)
            .toString()
            .replace('.', ''),
          total: total.toFixed(2).toString().replace('.', '')
        }
        data = {
          ...data,
          rabbitinfo: {
            prefix: this.inputRabbit.prefix,
            first_name: this.inputRabbit.first_name,
            last_name: this.inputRabbit.last_name,
            province: this.inputRabbit.province,
            district: this.inputRabbit.district,
            sub_district: this.inputRabbit.sub_district,
            zipcode: this.inputRabbit.zipcode,
            email: this.inputRabbit.email,
            idcard: this.inputRabbit.idcard,
            taxdeduction: this.inputRabbit.taxdeduction,
            address: this.shippingAddress,
            phone: this.customerPhone,
            remark: this.remark
          }
        }
        let url
        data.cart_ids = this.$store.state.cart_ids || []

        url = config.getConfig('serverUrl') + 'banktransfernotify'

        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }
        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = this.$liff.getOS()
            var version = this.$liff.getVersion()
            this.$liff.ready.then(() => {
              if (
                this.userid.indexOf('__') != -1 &&
                device &&
                version &&
                !this.$liff.isInClient()
              ) {
                data.from = 'livechat'
              }
            })
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }
        axios
          .post(url, data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (payment == '2c2p') {
                vm.orderid = response.orderid
                vm.amount = data.total
                this.$nextTick(() => {
                  vm.$refs.form2c2p.submit()
                })
              } else {
                vm.isCompleted = true
                vm.$store.dispatch('deleteAllItemsInCart')
                // eslint-disable-next-line
                if (vm.$liff.isInClient()) {
                  // eslint-disable-next-line no-undef
                  vm.$liff
                    .sendMessages([
                      {
                        type: 'text',
                        text: 'Order: ' + response.orderid
                      }
                    ])
                    .then(() => {})
                  // eslint-disable-next-line no-undef
                  vm.$liff.closeWindow()
                } else {
                  // eslint-disable-next-line no-undef
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close()
                    }
                  )
                }
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t(response.reason),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            } else if (response.responsecode == 201) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              let url = '/ecommerce/' + vm.pagename
              if (vm.userid && vm.userid != null && vm.userid != '') {
                url += '?userid=' + vm.userid
              }
              vm.$router.push({ path: url })
            } else {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again..'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
            vm.loading = false
          })
          .catch((err) => {
            console.log(err)
            vm.loading = false
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          })
      })
    }
  },
  watch: {
    birthdatemenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  }
}
</script>
<style></style>
